import { render, staticRenderFns } from "./MailSimulation.vue?vue&type=template&id=ed9a090c&"
import script from "./MailSimulation.vue?vue&type=script&lang=js&"
export * from "./MailSimulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports